export const PAGE_LAYOUT_SCROLL_CONTAINER_ID = 'page-layout-scroll-container';